/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const shelfPageVariables = {
  pageBreadCrumb: [] as unknown[],
  categoryLevel1: '',
  categoryLevel2: '',
  categoryLevel3: '',
  selectedFilterValue: '',
  eventType: '',
  productFilterSelection: '',
  productPart: [] as unknown[],
  productIdList: [] as unknown[],
  productLineCodeList: [] as unknown[],
  productBrandList: [] as unknown[],
  originalPartTypeIdList: [] as unknown[],
  productRepositoryIdList: [] as unknown[],
  bopusList: [] as unknown[],
  sthList: [] as unknown[],
  nddEligibleList: [] as unknown[],
  dealFlagList: [] as unknown[],
  productPrice: [] as unknown[],
  productCorePriceList: [] as unknown[],
  productNotAvailableList: [] as unknown[],
  resultsPerPage: '',
  resultCount: '',
  displayViewType: '',
  pageDepth: '',
  nddEligibleProductsCount: [] as unknown[],
  badgesInfo: [] as unknown[],
  productGuideSpcs: '',
  productFitmentFinderInformation: '',
  productFitmentFinderShown: '',
  nullCartridgeRecommendations: '',
  nullCartridgeSelected: '',
};
